// Client du CRM correspondant à l'acheteur : nom identique, sinon nom qui le contient.
function matchClient(acheteur, crmClients) {
  const acheteurLower = (acheteur || '').toLowerCase().trim();
  return (
    crmClients.find((c) => (c.nom || '').toLowerCase().trim() === acheteurLower) ||
    crmClients.find((c) => acheteurLower && (c.nom || '').toLowerCase().includes(acheteurLower))
  );
}

// Secteur existant du CRM le plus proche du secteur deviné par le LLM ('' si aucun).
function suggestSector(llmSector, crmClients) {
  const llmSectorLower = (llmSector || '').toLowerCase();
  const existingSectors = [...new Set(crmClients.flatMap((c) => c.secteurs || []))];
  const proche = (s) =>
    llmSectorLower.includes(s.toLowerCase()) ||
    s
      .toLowerCase()
      .split(/[&\s]+/)
      .some((mot) => mot.length > 3 && llmSectorLower.includes(mot));
  return existingSectors.find((s) => llmSectorLower && proche(s)) || '';
}

const liste = (label, arr) =>
  Array.isArray(arr) && arr.length ? `${label} : ${arr.join(' / ')}` : '';

// Notes de l'affaire : règle, classification, DCE et analyse du dossier.
function dealNotes(n) {
  const analysis = Array.isArray(n.boamp_document_analysis)
    ? n.boamp_document_analysis[0]
    : n.boamp_document_analysis;
  return [
    n.rule_reason ? `Règle : ${n.rule_reason}` : '',
    n.llm_justification ? `Classification : ${n.llm_justification}` : '',
    n.lien_dce ? `DCE : ${n.lien_dce}` : '',
    analysis?.solution_demandee ? `Solution demandée : ${analysis.solution_demandee}` : '',
    analysis?.budget ? `Budget : ${analysis.budget}` : '',
    liste('Technologies demandées', analysis?.technologies_demandees_json),
    liste('Fonctionnalités', analysis?.fonctionnalites_json),
    liste('Points forts', analysis?.points_forts_json),
    liste('Points faibles', analysis?.points_faibles_json),
    analysis?.recommandation ? `Recommandation : ${analysis.recommandation}` : '',
  ]
    .filter(Boolean)
    .join('\n');
}

/* Formulaire pré-rempli de conversion d'un appel d'offres en affaire : correspondance client et
   secteur suggérés (jamais appliqués automatiquement sans relecture — voir plan du 2026-09-03). */
export function tenderToDealForm(n, crmClients) {
  const matched = matchClient(n.acheteur, crmClients);
  const suggestedSector = suggestSector(n.llm_secteur, crmClients);
  return {
    nom: n.objet || '',
    clientMode: matched ? 'existing' : 'new',
    client_id: matched ? matched.id : '',
    newClientNom: n.acheteur || '',
    newClientSecteurs: suggestedSector ? [suggestedSector] : [],
    budget_estime: n.montant_estime || '',
    type_projet: n.llm_type_projet || '',
    notes: dealNotes(n),
  };
}
